import { render, staticRenderFns } from "./growth_chart.vue?vue&type=template&id=0f6de5a4&scoped=true&"
import script from "./growth_chart.vue?vue&type=script&lang=js&"
export * from "./growth_chart.vue?vue&type=script&lang=js&"
import style0 from "./growth_chart.vue?vue&type=style&index=0&id=0f6de5a4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6de5a4",
  null
  
)

export default component.exports